import React from 'react';
import Field from './Field'

export default class FieldRadioSelect extends Field {
    constructor(props) {
        super(props)

        this.state = {
            selectedOption: props.value
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            selectedOption: nextProps.value
        })
    }

    onOptionChange = item => {
        this.setState({
            selectedOption: item.value
        })

        if (this.props.onChange) {
            this.props.onChange(item.value)
        }
    }

    isOptionChecked = value => {
        return this.state.selectedOption === value
    }

    renderField() {
        return (
            <div className="configuration-radiogroup" data-radiogroup>
                {this.props.items.map(item => (
                    this.renderItem(item)
                ))}
            </div>
        )
    }

    renderItem(item) {
        let itemId = this.generateUniqueId()
        return (
            <div key={item.value} className="configuration-radiogroup-item">
                <input id={itemId} type="radio" checked={this.isOptionChecked(item.value)}
                       disabled={this.props.disabled} onChange={e => this.onOptionChange(item)}/>
                <label tabIndex="0" htmlFor={itemId}>{item.text}</label>
            </div>
        )
    }
}